import { IMenu } from './SideMenu';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import HomeIcon from '@mui/icons-material/Home';
import GridOnIcon from '@mui/icons-material/GridOn';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PostAddIcon from '@mui/icons-material/PostAdd';
import HandshakeIcon from '@mui/icons-material/Handshake';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { StyledLink } from '../../utils/CommonStyles';
import { urlName } from '../../utils/Functions';
import { theme } from '../../theme/theme';
import { useSelector } from 'react-redux';
import { selectProject } from '../../features/project/projectSlice';

const iconMap: { [icon: string]: { component: JSX.Element; color: string } } = {
  HomeIcon: { component: <HomeIcon />, color: '#002044' },
  GridOnIcon: { component: <GridOnIcon />, color: '#1f8a70' },
  PostAddIcon: { component: <PostAddIcon />, color: '#c1440e' },
  AssignmentIcon: { component: <AssignmentIcon />, color: '#6a4c93' },
  InsertChartIcon: { component: <InsertChartIcon />, color: '#1b7fbd' },
  HandshakeIcon: { component: <HandshakeIcon />, color: '#a17700' },
  AppointmentIcon: { component: <BookOnlineIcon />, color: '#2e8b57' },
  EventAvailableIcon: { component: <EventAvailableIcon />, color: '#c0267c' },
  ReceiptIcon: { component: <ReceiptIcon />, color: '#b03a2e' },
};

const MenuItem = (props: ChildProps) => {
  const { menu, handleClose } = props;
  const { project } = useSelector(selectProject);

  const menuIcon = iconMap[menu.icon];

  return (
    <StyledLink onClick={handleClose} to={`/dashboard/${urlName(project.name)}/${menu.link}`}>
      <ListItem
        sx={{
          color: theme.palette.primary.main,
          ':hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
          },
          ':hover .MuiListItemIcon-root': {
            color: '#fff',
          },
        }}
        button
      >
        <ListItemIcon sx={{ color: menuIcon?.color ?? theme.palette.primary.main }}>{menuIcon?.component}</ListItemIcon>
        <ListItemText primary={menu.title} />
      </ListItem>
    </StyledLink>
  );
};

interface ChildProps {
  menu: IMenu;
  handleClose: () => void;
}

export default MenuItem;
